<div *ngIf="errormessage" class="alert">{{errormessage}}</div>

<h1 class="hideonsmall"><label>{{ 'request.Application_h1' | translate }}</label></h1>

<form [formGroup]="requestForm" spellcheck="false" autocomplete="off" (ngSubmit)="onSubmit()">
  <section>
    <h2><label><span class="hideonsmall">1.&nbsp;</span>{{ 'request.PersonalInfo_h2' | translate }}</label></h2>
    <lebara-input formControlName="request:applicantName" icon="person" maxlength="96"></lebara-input>
    <lebara-input formControlName="request:applicantAddress" icon="house" maxlength="64"></lebara-input>
    <lebara-input formControlName="request:applicantPostcode" icon="blocks1" placeholder="9999 XX" maxlength="10"></lebara-input>
    <lebara-input formControlName="request:applicantCity" icon="blocks2" maxlength="32"></lebara-input>
    <lebara-input formControlName="request:applicantMobile" icon="mobile" placeholder="0612345678" maxlength="12"></lebara-input>
    <lebara-input formControlName="request:applicantEmail" icon="email" maxlength="254"></lebara-input>

    <lebara-date formControlName="request:transferDate" explanation="request.transferDate_explanation"></lebara-date>
    <p>{{ 'request.transferDate_explanation2' | translate }}</p>

  </section>
  <section>
    <h2><label><span class="hideonsmall">2.&nbsp;</span>{{ 'request.lebaraSIMCard_h2' | translate }}</label></h2>
    <p class="larger">{{ 'request.lebaraSIMCard_introduction' | translate }}</p>

    <lebara-input formControlName="request:lebaraMobile" icon="mobile" placeholder="0612345678" maxlength="12"></lebara-input>
    <p>{{ 'request.lebaraMobile_explanation' | translate }}</p>
    <lebara-input formControlName="request:lebaraSIMCard" icon="hash" placeholder="12345678901234" maxlength="20"></lebara-input>
    <p>{{ 'request.lebaraSIMCard_explanation' | translate }}</p>
  </section>

  <section>

    <h2><label><span class="hideonsmall">3.&nbsp;</span>{{ 'request.currentSubscription_h2' | translate }}</label></h2>

    <div *ngIf="!showDetailMode">
      <div class="bluebox">
      <img [src]="baseUrl + '/clientApp/dist/client-app/assets/images/information.svg'" />
      {{'request.simpleMode_blueBox' | translate}} <a href="#" (click)="onEditClick()">{{'request.simpleMode_edit' | translate}}</a></div>
      <lebara-checkbox formControlName="request:eeccConsent" [textkey]="'request.eeccConsent' + eeccOption?.value"></lebara-checkbox>
    </div>

    <div *ngIf="showDetailMode">
      <p class="larger">{{ 'request.eeccOption_introduction' | translate }}</p>
      <lebara-select formControlName="request:eeccOption" [items]="eeccOptionList"></lebara-select>
      <lebara-checkbox formControlName="request:eeccConsent" [textkey]="'request.eeccConsent' + eeccOption?.value">
      </lebara-checkbox>
    </div>

  </section>

  <div class="submitcontainer">
    <div>
      <div *ngIf="submitErrorCode" class="errmsg">{{submitErrorCode | translate }}</div>
    </div>
    <div>
      <input type="submit" [value]="'request.submit_text' | translate" class="primaryButton-body" id="submitButton" [class.disabled]="!requestForm.valid || waiting">
    </div>
  </div>

  <!--<a href="#" routerLink="/{{homeSvc.languageCode}}/done">Ga naar done</a>-->

</form>
